import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { Field, reduxForm, getFormValues, getFormSyncErrors } from 'redux-form'

import { validRequired } from '../form/validate'
import { verifyPhoneNumber } from '../../actions/phoneNumberActions'

import { Label, InputGroup, renderError, Warning } from '../form'
import PhoneNumberField, { validPhoneNumber } from '../form/PhoneNumberField'

import PhoneVerificationForm from './PhoneVerificationForm'
import Button from '../display/Button'

const FieldFlexWrapper = styled.div`
  margin: 0 -8px;
  margin-bottom: 8px;
`

const FieldFlex = styled.div`
  margin: 8px;
`

class MobilePhoneNumber extends React.Component {
  handleKeyPressEnter = (e) => {
    const { handleSubmit } = this.props
    if (e.key === 'Enter') {
      e.preventDefault()
      handleSubmit()
    }
  }

  render() {
    const {
      auth,
      invalid,
      currentUser,
      formValues,
      handleSubmit,
      dirty,
      noMargin,
    } = this.props

    const isPhoneNumberVerified = !dirty && currentUser?.phone_number_verified

    return (
      <InputGroup noMargin={noMargin}>
        <Label>Mobile phone number</Label>
        <FieldFlexWrapper>
          <FieldFlex style={{ flex: 1 }}>
            <PhoneNumberField
              name="phone_number"
              showAsValid={isPhoneNumberVerified}
              onKeyPress={this.handleKeyPressEnter}
              validate={[validRequired, validPhoneNumber]}
              className={isPhoneNumberVerified && 'qa-phone-number-verified'}
              rounded
            />
          </FieldFlex>
          {!isPhoneNumberVerified && (
            <FieldFlex style={{ minWidth: 160, flex: 0 }}>
              <Button
                type="button"
                className="inline-button"
                onClick={handleSubmit}
                disabled={
                  auth.verifyingPhoneNumber ||
                  auth.phoneNumberVerificationSent ||
                  invalid
                }
                rounded
                uppercase={false}
              >
                Verify by SMS
              </Button>
            </FieldFlex>
          )}
        </FieldFlexWrapper>
        {dirty && (
          <Warning style={{ marginTop: 16 }}>
            You will have to verify this phone number to save it.
          </Warning>
        )}
        <div>
          <Field
            name="phone_number"
            component={renderError}
            validate={[validRequired, validPhoneNumber]}
          />
        </div>
        {!isPhoneNumberVerified && auth.phoneNumberVerificationSent && (
          <PhoneVerificationForm
            phoneNumber={formValues.phone_number}
            roundedInputs
          />
        )}
      </InputGroup>
    )
  }
}

const MobilePhoneNumberForm = reduxForm({
  form: 'MobilePhoneNumber',
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(MobilePhoneNumber)

export default connect(
  ({ auth, ...state }) => ({
    updating: auth.updating,
    currentUser: auth.currentUser,
    initialValues: {
      phone_number: auth.currentUser && auth.currentUser.phone_number,
    },
    formValues: getFormValues('MobilePhoneNumber')(state),
    formSyncErrors: getFormSyncErrors('MobilePhoneNumber')(state),
    auth,
    state,
  }),
  (dispatch) => ({
    onSubmit: ({ phone_number }) => {
      dispatch(verifyPhoneNumber(phone_number))
    },
  })
)(MobilePhoneNumberForm)
